
const CheapestInternet = () => {
    return (
        <>
            <div className="section-inner bg-top-left move-top-bottom tt-overflow-hidden lazyloaded " id="service">
               
                <h1 className="title-block__title pink text-center mt-5">
                CHEAPEST INTERNET® PLAN
               
                </h1>
                <h3 className="title-block__title text-white text-center mt-3">
                Want to save on Internet®? Here’s how you can get the best deals
                </h3>
               
                <div className="container container-fluid-xl mt-5 d-flex justify-content-center">
                    <img src="images/third.jpeg"/>
                </div>
            </div></>
    )
}

export default CheapestInternet